import { render, staticRenderFns } from "./EditRecipe.vue?vue&type=template&id=fced84bc&scoped=true&"
import script from "./EditRecipe.vue?vue&type=script&lang=js&"
export * from "./EditRecipe.vue?vue&type=script&lang=js&"
import style0 from "./EditRecipe.vue?vue&type=style&index=0&id=fced84bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fced84bc",
  null
  
)

export default component.exports